import { ReportNavigationHeaderComponent } from './report-navigation-header.component';

export default angular
  .module('sfMobile.components.report-navigation-header', [])
  .component('sfReportNavigationHeader', ReportNavigationHeaderComponent).name;
